<dialog 
#modal 
class="root-container"
dialogBackdrop>
  <dialog-header slot="end">
    <i class="bi bi-x-lg close-button" (click)="onDismiss()"></i>
  </dialog-header>

  <div class="header">
    <div class="title">Change profile photo</div>
    <span class="sub-title">Supported format: JPG, JPEG, PNG. Max file size: 5MB</span>
  </div>

  <div class="body">
    @if(!showCamera){
      <div class="options">
        <dropbox 
        class="dropbox" 
        accepts=".jpg, .jpeg, .png"
        [(files)]="dropboxFile" 
        [multiple]="false" 
        [withPreview]="true"/>
        @if (!dropboxFile()) {
          <div class="divider">
            <span>or</span>
          </div>
          <button-component (click)="showCamera = true" type="primary" bi_icon="bi-camera" text="Take a photo" [width]="300"/>
        }
        @else {
        {{ dropboxFile()![0].file.name  }}
          <button-component (click)="submit()" text="Upload" type="primary" />
        }
      </div>
      <input type="file" accept='.jpg, .jpeg, .png' #fileInput hidden />
    }
    @else {
      <camera #camera (onCapture)="cameraFile.set($event)"/>

      <div class="d-flex justify-content-center">
        @if (!camera.hasCapture() && camera.hasPermission()){
          <button-component (click)="camera.capture()" text="Take Photo" type="primary" bi_icon="bi-camera" [disabled]="!camera.video_stream()" />
          <button-component (click)="showCamera = false" text="Back" type="secondary"/>
        }
        @if (camera.hasCapture()){
          <button-component (click)="submit()" text="Upload" type="primary" />
          <button-component (click)="camera.clear()" text="Retake" type="secondary" bi_icon="bi-camera"/>
        }
      </div>
    }
  </div>
</dialog>
